import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const Container = styled('div', { label: 'Error' })(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
}));

const ErrorMsg = styled(Typography, { label: 'ErrorMsg' })(({ theme }) => ({
  fontSize: '12px',
  lineHeight: '18px',
  marginTop: '5px',
  color: theme.palette.error.main,
}));

interface Props {
  error: string | string[];
}

const Error = (props: Props) => {
  const { error } = props;
  const errors = Array.isArray(error) ? error : [error];

  return (
    <Container>
      {errors.map((error, index) => (
        <ErrorMsg key={`${error}-${index}`}>{error}</ErrorMsg>
      ))}
    </Container>
  );
};

export default Error;
